import { SCHEDULER_QUERY_KEYS } from 'api/Schedular/keys';
import { queryClient } from 'lib/queryClient';

export const handleProjectCreateSuccess = () => {
  queryClient.invalidateQueries({
    queryKey: [SCHEDULER_QUERY_KEYS.LIST_PROJECTS],
  });
};
